import { Footer } from "@/components/marketing/Footer";
import { Navbar } from "@/components/marketing/Navbar";
import { env } from "@/lib/env";
import Categories from "@/sections/Categories";
import { FinalCta } from "@/sections/FinalCta";
import Hero from "@/sections/Hero";
import { HowItWorks } from "@/sections/HowItWorks";
import { LaunchFinalCta } from "@/sections/LaunchFinalCta";
import { SecurityPrivacy } from "@/sections/SecurityPrivacy";
import { WhoWeServe } from "@/sections/WhoWeServe";

export function Landing() {
  return (
    <main
      data-landing-scroll
      className="relative flex min-h-screen w-full flex-col overflow-x-hidden bg-background text-foreground selection:bg-white selection:text-black"
    >
      <div className="fixed inset-x-0 top-0 z-30">
        <Navbar />
      </div>
      <Hero />
      <Categories />
      <WhoWeServe />
      <HowItWorks />
      <SecurityPrivacy />
      {env.launched ? <LaunchFinalCta /> : <FinalCta />}
      <Footer />
    </main>
  );
}
